import {
	MixinsPageJump
} from './MixinsPageJump';

export const mixinsFunc = {
	proDetail(e) {
		console.log(e.currentTarget, e.currentTarget.getAttribute('data-id'))
	},
	// 参考小程序的，待验证
	setData(obj) {
		let that = this;
		let keys = [];
		let val, data;
		Object.keys(obj).forEach(function (key) {
			keys = key.split('.');
			val = obj[key];
			data = that.$data;
			keys.forEach(function (key2, index) {
				if (index + 1 == keys.length) {
					that.$set(data, key2, val);
				} else {
					if (!data[key2]) {
						that.$set(data, key2, {});
					}
				}
				data = data[key2];
			})
		});
	},
	myLoading(bShowMyLoading = true) {
		this.setData({
			showMyLoading: !!bShowMyLoading
		})
	},
	nothing(e) {
		e = e || event;
		// 兼容写法（阻止冒泡）
		(typeof e.stopPropagation == 'function') ? e.stopPropagation() : e.cancelBubble = true;
		e.preventDefault()
		return null
	},
	...MixinsPageJump

}
